import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { Popover } from 'primeng/popover';

export interface PrestadoresAcreditados26FilterData {
  fil180Dias: number;
  filAcreditado: number;
  filRps: number[];
  filElegivel: number;
}

const SIM_NAO_OPTIONS: SelectItem[] = [
  { label: 'Sim', value: 1 },
  { label: 'Não', value: 0 },
];

/** Valores de `cd_rps` gravados pelo worker do relatório 2.6. */
export const SITUACAO_RPS_OPTIONS: SelectItem[] = [
  { label: 'Não registrado', value: 0 },
  { label: 'Registrado sem vínculo', value: 1 },
  { label: 'Registrado com vínculo', value: 2 },
];

@Component({
  selector: 'bl-prestadores-acreditados-2-6-filtro',
  templateUrl: './filtro.component.html',
  styleUrls: ['./filtro.component.scss'],
  standalone: false,
})
export class PrestadoresAcreditados26FiltroComponent implements OnChanges {
  @ViewChild('filterPanel') filterPanel: Popover;

  @Input() data: PrestadoresAcreditados26FilterData;

  @Output() dataChange = new EventEmitter<PrestadoresAcreditados26FilterData>();
  @Output() onChange = new EventEmitter<PrestadoresAcreditados26FilterData>();

  readonly acreditado180DiasOptions = SIM_NAO_OPTIONS;
  readonly acreditadoOptions = SIM_NAO_OPTIONS;
  readonly rpsOptions = SITUACAO_RPS_OPTIONS;
  readonly elegivelOptions = SIM_NAO_OPTIONS;

  count = 0;
  label = '';

  localFil180Dias: number = null;
  localFilAcreditado: number = null;
  localFilRps: number[] = [];
  localFilElegivel: number = null;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data']) {
      this.updateLabel();
    }
  }

  private updateLabel() {
    this.count = Object.values(this.data ?? {}).filter(valor =>
      Array.isArray(valor) ? valor.length > 0 : valor !== null && valor !== undefined,
    ).length;
    this.label = this.count === 0 ? '' : this.count + ' filtro' + (this.count > 1 ? 's' : '');
  }

  onShow($event: Event) {
    this.localFil180Dias = this.data?.fil180Dias ?? null;
    this.localFilAcreditado = this.data?.filAcreditado ?? null;
    this.localFilRps = [...(this.data?.filRps ?? [])];
    this.localFilElegivel = this.data?.filElegivel ?? null;
    this.filterPanel.toggle($event);
  }

  onApply() {
    this.data = {
      fil180Dias: this.localFil180Dias,
      filAcreditado: this.localFilAcreditado,
      filRps: this.localFilRps,
      filElegivel: this.localFilElegivel,
    };
    this.updateLabel();
    this.dataChange.emit(this.data);
    this.onChange.emit(this.data);
    this.filterPanel.hide();
  }

  onClear() {
    this.localFil180Dias = null;
    this.localFilAcreditado = null;
    this.localFilRps = [];
    this.localFilElegivel = null;
    this.data = { fil180Dias: null, filAcreditado: null, filRps: [], filElegivel: null };
    this.count = 0;
    this.label = '';
    this.dataChange.emit(this.data);
    this.onChange.emit(this.data);
    this.filterPanel.hide();
  }
}
